/**
 *
 * @file 数据看板
 *
 **/

import { makeAutoObservable /* flow */ } from 'mobx';

class DataBoard {
    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }

    entId = null;

    entOptions = [];

    /*  queryEntOption = flow(function* (dft) {
        try {
            // const { data } = yield getAllCategory();
            // return Promise.resolve();
        } catch {
            return Promise.reject();
        }
    }); */

    setEntId(id) {
        this.entId = id;
    }

    setEntOptions(arr) {
        this.entOptions = arr;
    }
}

export default new DataBoard();
